<template>
  <div class="tableWithPerPageSelection">
    <div class="entete border-entete">
      <div class="is-paddingless section">
        <div class="level">
          <div class="level-left">
            <div class="columns is-gapless">
              <div class="column">
                <h1 class="title is-size-3" >
                  {{ $t('listeProduitReseauTempoDispo.title') }}
                </h1>
                <breadcrumb :breadcrumb="breadcrumb"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="level mgt-20px columns">
      <div class="level-left column is-6">
        <div class="columns">
          <form @submit.prevent="recherche()"
                class="column is-6 pdr-0">
            <b-input :placeholder="$t('listeProduitReseauTempoDispo.actions.search')"
                     type="search"
                     v-model="brief.auto"
                     icon="magnify">
            </b-input>
          </form>
        </div>
      </div>
      <div class="column is-6 level-right">
        <div class="column is-pulled-right is-paddingless">
          <parametrage-table class="mgl-10px"
            :reference-table="referenceTable"
            @endLoadParamtre="startArrayRendering = true">
          </parametrage-table>
        </div>
        <div class="column is-pulled-right is-paddingless">
          <button class="button" @click='showPanier = !showPanier'>
            <b-icon icon="cart-outline" size="is-small" type="is-default"></b-icon>
            <span class="is-size-7"> {{$t('listeProduitUnitaire.panier')}} </span>
          </button>
          <div class="info-circle-right background-danger is-pulled-right"
               v-if="panier.length > 0">
            <span class="inside-circle">{{ panier.length > 9 ? '9+' : panier.length }}</span>
          </div>
        </div>
        <div class="column is-pulled-right is-paddingless">
          <button class="button" @click='showBrief = !showBrief'>
            <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
            <span class="is-size-7">{{$t('listeProduitReseauTempoDispo.actions.brief')}}</span>
          </button>
          <div class="info-circle-right background-primary is-pulled-right"
               :class="{'is-invisible': nombreCritere === 0}">
            <span class="inside-circle">{{ nombreCritere }}</span>
          </div>
        </div>
      </div>
    </div>
    <v-server-table
      url=""
      v-if="startArrayRendering && mountedLoadingEnd"
      :columns="columns"
      :options="options"
      @loaded="finLoading"
      @loading="debutLoading"
      :ref="referenceTable">
      <template slot='afterTable'>
        <table-items-in-view
          :perPage="resultPerPage"
          @input="$refs[referenceTable].setLimit($event)"/>
      </template>
      <div slot="selected" slot-scope="props" class="has-text-centered">
        <button @click="addOrDeleteReseauInPanier(props.row)"
          class="ripple button" :class="getColorAddPanier(props.row.id)">
          <b-icon icon="cart"></b-icon>
        </button>
      </div>
      <div slot="reference" slot-scope="props">
        <router-link :to="{ name: 'c.bodac.catalogue-reseau',
        params: { id: props.row.id, isFromListeProduitReseau: true }}" class="lien"
                     :class="{'text-access-no-permission':
                     !checkPermissions(permCatalogue.lecture)}">
          {{ props.row.reference }}
        </router-link>
      </div>
      <div slot="format" slot-scope="props">
        {{ getFormatLibelle(props.row.produitReseau.formatId) }}
      </div>
      <div slot="nbFacesReelles" slot-scope="props" class="is-pulled-right">
        {{ props.row.produitReseau.affectationsReseauFace.length }}
      </div>
      <div slot="typeReseau" slot-scope="props">
        {{ getTypeReseauLibelle(props.row.produitReseau.typeReseauId) }}
      </div>
      <div slot="societe" slot-scope="props">
        <div>{{ getLibelleSociete(props.row.supportCommercial.societeId) }}</div>
      </div>
      <div slot="agence" slot-scope="props">
        <div>{{ getAgenceLibelle(props.row.agenceId) }}</div>
      </div>
      <div slot="nbFacesPrevues" slot-scope="props" class="is-pulled-right">
        {{ props.row.nbFacesPrevues}}
      </div>
    </v-server-table>
    <transition name="custom-classes-transition"
                enter-active-class="animate__animated animate__slideInRight"
                leave-active-class="animate__animated animate__slideOutRight" :duration="10">
      <div class="componentBrief" v-if="showBrief || showPanier">
        <brief-liste-produit-reseau-tempo-dispo v-if="showBrief === true"
                                           @toggleFiltre="showBrief = !showBrief"
                                           @recherche="makeRechercheFilter()"/>
        <panier-ajout-reseau-tempo-dispo v-if="showPanier"
                                         @parametrageSelection="openParametrageSelection"
                                         @togglePanier="showPanier = !showPanier"/>
      </div>
    </transition>
    <b-modal v-model="popUpParametrageSelection"
             has-modal-card width="1400px"
             class="modal">
      <pop-up-parametrage-selection :parametrage-selection="parametrageSelection"
                                    :weeksSelect="weeksSelect"
                                    :societe-id="societeActive.id"/>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import { PARAMETRES_INTERNE_KEYS, PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import { CATALOGUE } from '@/configuration/permissionsBodacConf';
import breadcrumb from '@/components/general/breadcrumb';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import {
  NO_PER_PAGE_VALUE,
  RESULTS_PER_PAGE,
  SORT_ICON, TEXTS,
} from '@/configuration/clientTableConf';
import TableItemsInView from '@/components/general/TableItemsInView';
import { ADD_LIGNE_IN_PANIER, DELETE_LIGNE_IN_PANIER } from '@/store/modules/produitReseauTempo-mutation-type';
import { getSecteursByIds } from '@/services/commun/secteur/getSecteurs';
import { COMMERCIAL } from '@/configuration/parametrage/secteurConf';
import briefListeProduitReseauTempoDispo from '@/components/outils/reseauTempo/briefListeProduitReseauTempoDispo';
import panierAjoutReseauTempoDispo from '@/components/outils/reseauTempo/panierAjoutReseauTempoDispo';
import { LIBRE, OPTION } from '@/configuration/optionBlocage/optionBlocage';
import popUpParametrageSelection from '@/components/outils/reseauTempo/parametrageSelection/p_parametrageSelection';
import subscribeMutation from '@/services/store/subscribeMutation';
import { columnsSplice } from '@/services/general/columns';
import { SET_DETECT_CHANGE_SOCIETE } from '@/store/modules/societe-mutation-type';
import parametrageTable from '@/components/general/parametrageTable';
import { REFERENCE_OUTIL_PRODUIT_RESEAU_TEMPO } from '@/configuration/general/referenceTableConf';

const Parametres = createNamespacedHelpers('parametres');
const Permissions = createNamespacedHelpers('permissions');
const ProduitReseauTempo = createNamespacedHelpers('produitReseauTempo');
const Societes = createNamespacedHelpers('societe');
const User = createNamespacedHelpers('user');

export default {
  data() {
    return {
      permCatalogue: CATALOGUE,
      showBrief: false,
      showPanier: false,
      popUpParametrageSelection: false,
      unsubscribeValue: null,
      startArrayRendering: false,
      mountedLoadingEnd: false,
      parametrageSelection: {
        produitLoc: null,
        niveauDeDispo: LIBRE,
        etatSouhaiteSelect: OPTION,
      },
      weeksSelect: [],
      referenceTable: REFERENCE_OUTIL_PRODUIT_RESEAU_TEMPO,
      resultPerPage: RESULTS_PER_PAGE,
    };
  },
  components: {
    breadcrumb,
    TableItemsInView,
    briefListeProduitReseauTempoDispo,
    panierAjoutReseauTempoDispo,
    popUpParametrageSelection,
    parametrageTable,
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...ProduitReseauTempo.mapGetters({
      brief: 'brief',
      produitsReseauTempo: 'items',
      totalCount: 'total',
      panier: 'panier',
    }),
    ...Societes.mapGetters({
      societesInformations: 'societesInformations',
      societeActive: 'societeActive',
      societeActiveId: 'societeActiveId',
      agenceActive: 'agenceActive',
    }),
    ...User.mapGetters({
      user: 'user',
    }),
    colorBackgroundSelectTotal() {
      if (this.allProduiReseauTempoSelected && this.produitsReseauTempo.length > 0) {
        return 'has-background-success';
      }
      return 'has-background-primary is-cursor-pointer';
    },
    allProduiReseauTempoSelected() {
      return (this.produitsReseauTempo.every((produit) => {
        return this.panier.find((lignePanier) => { return lignePanier.id === produit.id; });
      }));
    },
    breadcrumb() {
      return [
        { title: this.$i18n.t('listeProduitReseauTempoDispo.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('listeProduitReseauTempoDispo.breadcrumb.liste'), route: '', isActive: true },
      ];
    },
    nombreCritere() {
      const nbCritere = calculNombreCritere(this.brief, ['auto', 'actif']);
      return nbCritere > 9 ? '+9' : nbCritere;
    },
    columns() {
      const columns = ['selected', 'reference', 'libelle', 'produitReseau.adresse.ville', 'format', 'typeReseau', 'nbFacesPrevues', 'nbFacesReelles', 'agence', 'societe'];
      if (this.societesInformations.length === 1 || this.filtrerProduitParSociete
        || this.filtrerProduitParAgence) {
        columnsSplice(columns, 'societe');
      }
      return columns;
    },
    moduleSecteurActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleSecteur.key);
    },
    filtrerProduitParSociete() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.filtrerProduitParSociete.key);
    },
    filtrerProduitParAgence() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.filtrerProduitParAgence.key);
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          reference: this.$i18n.t('listeProduitReseauTempoDispo.tabs.reference'),
          libelle: this.$i18n.t('listeProduitReseauTempoDispo.tabs.libelle'),
          societe: this.$i18n.t('listeProduitReseauTempoDispo.tabs.societe'),
          'produitReseau.adresse.ville': this.$i18n.t('listeProduitReseauTempoDispo.tabs.ville'),
          format: this.$i18n.t('listeProduitReseauTempoDispo.tabs.format'),
          typeReseau: this.$i18n.t('listeProduitReseauTempoDispo.tabs.type'),
          nbFacesPrevues: this.$i18n.t('listeProduitReseauTempoDispo.tabs.nbFacesPrevues'),
          nbFacesReelles: this.$i18n.t('listeProduitReseauTempoDispo.tabs.nbFacesReelles'),
          agence: this.$i18n.t('listeProduitReseauTempoDispo.tabs.agence'),
          selected: (h) => {
            return h(
              'button', {
                attrs: {
                  class: 'border-none has-text-centered height-35 ' + this.colorBackgroundSelectTotal,
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: 'cart',
                    type: 'is-white',
                  },
                }),
              ],
            );
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        texts: TEXTS,
        sortable: ['reference', 'libelle', 'produitReseau.adresse.ville', 'format', 'typeReseau'],
        columnsClasses: {
          selected: 'colonneSelected has-text-centered pd-5px',
        },
        requestFunction: ((data) => {
          if (this.filtrerProduitParAgence) {
            this.brief.agencesId = this.agenceActive.map((agence) => agence.agenceId);
          }
          if (!data.query) data.query = cloneDeep(this.brief);
          if (this.filtrerProduitParSociete) {
            data.query.societeId = this.societeActiveId;
          }
          return this.loadProduitsReseauTempo(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.produitsReseauTempo,
            count: this.totalCount,
          };
        }),
      };
    },
  },
  methods: {
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...ProduitReseauTempo.mapActions({
      loadProduitsReseauTempo: 'loadProduits',
    }),
    ...Societes.mapActions({
      loadSocietes: 'loadSocietes',
    }),
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
      loadParametresInterne: 'loadParametresInterne',
    }),
    ...ProduitReseauTempo.mapMutations({
      addLigne: ADD_LIGNE_IN_PANIER,
      deleteLigne: DELETE_LIGNE_IN_PANIER,
    }),
    getAgenceLibelle(agenceId) {
      const agenceFind = this.user.agences.find((agence) => {
        return agence.agenceId === agenceId;
      });
      if (agenceFind) return agenceFind.libelleAgence;
      return '';
    },
    openParametrageSelection() {
      this.showPanier = false;
      this.popUpParametrageSelection = true;
    },
    selectAll() {
      const loadingComponent = this.$buefy.loading.open();
      const selectAll = !this.allProduiReseauTempoSelected;
      this.produitsReseauTempo.forEach((produit) => {
        this.addOrDeleteReseauInPanier(produit, selectAll);
      });
      loadingComponent.close();
    },
    getFormatLibelle(id) {
      const formatFind = this.parametre(PARAMETRES_KEYS.format).find((format) => {
        return format.id === id;
      });
      return formatFind ? formatFind.libelle : null;
    },
    getTypeReseauLibelle(id) {
      const typeReseauFind = this.parametre(PARAMETRES_KEYS.typeReseau).find((typeReseau) => {
        return typeReseau.id === id;
      });
      return typeReseauFind ? typeReseauFind.libelle : null;
    },
    getLibelleSociete(societeId) {
      const societe = this.societesInformations.find((societe) => {
        return societe.id === societeId;
      });
      return societe ? societe.libelle : null;
    },
    makeRechercheFilter() {
      if (this.showBrief) this.showBrief = !this.showBrief;
      this.recherche();
    },
    recherche() {
      this.$refs[this.referenceTable].refresh();
    },
    goFirstPage() {
      this.$refs[this.referenceTable].setPage(1);
    },
    debutLoading() {
      if (this.loadingComponent) this.loadingComponent.close();
      this.loadingComponent = this.$buefy.loading.open();
    },
    finLoading() {
      this.loadingComponent.close();
    },
    isInPanier(idProduit) {
      return (this.panier.find((ligne) => { return ligne.id === idProduit; }));
    },
    getColorAddPanier(idProduit) {
      return this.isInPanier(idProduit) ? 'is-success' : 'is-primary';
    },
    addOrDeleteReseauInPanier(reseauTempo, selectAll) {
      const loadingComponent = this.$buefy.loading.open();
      if (this.isInPanier(reseauTempo.id)) {
        if (!selectAll) this.deleteLigne(reseauTempo.id);
      } else {
        this.addLigne({
          libelle: reseauTempo.libelle,
          reference: reseauTempo.reference,
          id: reseauTempo.id,
          produitParDefautId: reseauTempo.produitReseau.produitParDefautId,
        });
      }
      loadingComponent.close();
    },
    updateAgenceAndRecherche() {
      if (this.filtrerProduitParAgence) {
        this.brief.agencesId = this.agenceActive.map((agence) => agence.agenceId);
      }
      this.recherche();
    },
  },
  beforeDestroy() {
    if (this.filtrerProduitParSociete || this.filtrerProduitParAgence) {
      this.unsubscribeValue();
    }
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadSocietes({});
      await this.loadParametres([PARAMETRES_KEYS.format, PARAMETRES_KEYS.typeReseau]);
      await this.loadParametresInterne([
        PARAMETRES_INTERNE_KEYS.filtrerProduitParSociete.key,
        PARAMETRES_INTERNE_KEYS.filtrerProduitParSociete.key,
        PARAMETRES_INTERNE_KEYS.moduleSecteur.key,
      ]);
      if (this.filtrerProduitParSociete || this.filtrerProduitParAgence) {
        this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.updateAgenceAndRecherche, this.goFirstPage);
      }
      if (this.filtrerProduitParAgence) {
        this.brief.agencesId = this.agenceActive.map((agence) => agence.agenceId);
      }
      if (this.moduleSecteurActive) {
        if (this.user.secteursId.length === 0
          && this.brief.secteurIds.length > 0) {
          this.brief.secteurIds = (await getSecteursByIds(
            this.brief.secteurIds,
            COMMERCIAL)).map(secteur => secteur.id);
        } else this.brief.secteurIds = this.user.secteursId ?? [];
      }
      this.setInformationPage(this.$t('pageGescom.produitReseauTempoDispo.liste'));
      this.parametrageSelection.produitLoc = this.societeActive.produitIdDefautRegroupement;
      this.mountedLoadingEnd = true;
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};

</script>
